import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import RequestModal from './RequestModal';

const FloatingRequestButton = () => {
  const [show, setShow] = useState(false);

  return (
    <>
      <Button
        variant="primary"
        onClick={() => setShow(true)}
        style={{
          position: 'fixed',
          right: '20px',
          bottom: '20px',
          borderRadius: '9999px',
          padding: '12px 16px',
          boxShadow: '0 6px 12px rgba(0,0,0,0.15)',
          zIndex: 1050,
        }}
        aria-label="Request video/blog"
        title="Request video/blog/prompt"
      >
        Request Info
      </Button>

      <RequestModal show={show} onHide={() => setShow(false)} />
    </>
  );
};

export default FloatingRequestButton;
